"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickSeekTime = void 0;
exports.QuickSeekTime = 10;
//# sourceMappingURL=constants.js.map